<template>
  <div id='Header'>
     
    <div class='headerBox'>
        <div class='headerRouter'>
              <router-link :to="item.name"  v-for="item in computedRouterList">
                      <div :style='item.active?"color:#C25E4D":""' class='headerRouterTxt'>{{item.title}}</div>
              </router-link>
        </div>
        <div class='headerLogoBox' >
          <router-link to="/"  >
                      <img src="../assets/logo2.png" alt="" class='headerLogo' style='cursor:pointer;'>
              </router-link>
           
        </div>
        <div class='headerRouter2'> 
          <a >
              <div class='cartNumBox' style='cursor:pointer;' @click='openCart'>
                  <img :src='require("@/assets/tab-bar/indexcart.png")' />
                  <div class='cartNum' v-if='computedNum>0'>{{computedNum}}</div>
              </div>
              <div @click='openCart' style='cursor:pointer;'>我的橘袋{{computedBally}}</div>

          </a>       
        </div>
    </div>
    <div id="ball" ></div>
    <CreatOrder />
  </div>
</template>

<script>
import CreatOrder from '@/components/creatOrder.vue'

export default {
  name: 'Header',
  props: {
    msg: String,
    num: Number,
  },
  components: {
      CreatOrder,
  },
  data:function () {
    return{
      txt:"小橘袋",
      routerList:[
              {title:"首页",name:"/"},
              {title:"全部产品",name:"/product"},
              {title:"关于橘袋",name:"/about"},
              {title:"联系我们",name:"/contact"},
              ],
      cartNum:this.$store.state.cartNum,
    }
  },
   computed: {
    computedRouterList () {
      this.routerList.forEach((item)=>{
        item.active=false
        if(item.name == this.msg){
          item.active=true
        }
      })
      return this.routerList
    },
     computedRouterList2 () {
      this.routerList2.forEach((item)=>{
        item.active=false
        if(item.name == this.msg){
          item.active=true

        }
      })
      return this.routerList2
    },
    computedNum(){
      return  this.$store.state.cartNum
    },
    computedBallx(){
      console.log(this.$store.state.ballx)

      return 
    },
    computedBally(){
      $("#ball").css("top",this.$store.state.bally)
      $("#ball").css("left",this.$store.state.ballx)
      return 
    }
  },
  created:function () {
    console.log(document.body.clientWidth)
     if(document.body.clientWidth<800){
      $(".headerRouterTxt").css("border","2px solid #000")
  
    }
  },
  methods: {
      openCart(e){
        
        if( this.$store.state.orderStep>0){
         this.$store.commit("saveOrderStep",0)
        }else{
          this.$store.commit("saveOrderStep",1)
        }
      }
  },

}
</script>  

<style>
#Header{
  width: 100vw;
  height: 48px;
  z-index: 99;
  background-color: #fff;
  position: fixed;
  
}
a:link{
text-decoration:none;
}
a:visited{
text-decoration:none;
}
a:hover{
text-decoration:none;
}
a:active{
text-decoration:none;
}
.headerBox{
  width: 90vw;
  margin: 0 auto;
  color: #141414;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.headerBox a{
  color: #141414;
  font-weight:600;
  font-family:PingFangSC-Medium;
  text-decoration:none;
}
.headerRouter{
  /*position: absolute;*/
  /*left: 3vw;*/
  /*top:0;*/
  display: flex;
  height:48px;
  font-size:16px;
  font-family:PingFangSC-Medium;
  font-weight:600;
  color:rgba(20,20,20,1);
  line-height:48px;
}

.headerRouter a:hover{
  color:rgba(20,20,20,1);
  text-decoration:none;
}
.headerRouter div{
   /*width:65px;*/
   padding-right:1.3vw;
   text-align:center;
   height:48px;
}
.headerLogoBox{
  width: 214px;
  height:22px;
  padding-top: 16px;
  position: absolute;
  top:0;
  left:50%;
  margin-left: -107px; 
}
.headerLogoBox img{
  width: 214px;
  height:22px;
}

.headerRouter2{
  display: flex;
   /*position: absolute;
  right: 3vw;
  top:0;*/
}
.headerRouter2 a{
  display: flex;
   height:48px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  line-height: 48px;
  margin-right: 24px;
}
.headerRouter2 a:hover{
  color:rgba(20,20,20,1);
  text-decoration:none;
}
.headerRouter2 a img{
  width: 15px;
  height: 17px;
  margin-right: 7px;
  position: relative;
  top:-2px;
}
.cartNumBox{
  position: relative;
}
.cartNum{
  background:rgba(194,94,77,1);
  min-width: 15px;
  height:15px;
  line-height: 15px;
  border-radius: 15px;
  position: absolute;
  top: 10px;
  right: 0px;
  font-size: 12px;
  color: #fff;
}

#ball{
  background-color: #C25E4D;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  display: none;
  z-index: 999 !important;
  position: fixed;
}

@media screen and (max-device-width: 800px) {
.headerRouterTxt{
  font-size:14px;
}
}
</style>